// extracted by mini-css-extract-plugin
module.exports = {"root":"Navigation_root__1nXKr","App":"Navigation_App__2l5OI","User":"Navigation_User__3nTMG","Inbox":"Navigation_Inbox__3BjbP","Navigation":"Navigation_Navigation__1DBxe"};